import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=6b00742a"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"
import style0 from "./EmailModal.vue?vue&type=style&index=0&id=6b00742a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports